(function () {
  'use strict';
  if (window.ptStyleGuideBound) return;
  window.ptStyleGuideBound = true;
  var selectSelector = '[data-matching-style-select], [data-fabric-style-select], [data-solo-style-select]';

  function resolve(gender) {
    return window.PTStyleCatalog.resolve(gender);
  }

  function owner(trigger) {
    return trigger.closest('[data-matching-person], [data-fabric-set], [data-solo-options]');
  }

  function matchingOption(select, card) {
    if (!select || select.disabled) return null;
    var options = Array.from(select.options).filter(function (option) {
      return option.value && !option.disabled && option.value === card.dataset.ptStyleCode;
    });
    return options.length === 1 ? options[0] : null;
  }

  function refreshTriggers() {
    document.querySelectorAll('[data-pt-style-guide]').forEach(function (trigger) {
      trigger.hidden = !resolve(trigger.dataset.ptStyleGuide);
    });
  }

  // Capture before the theme's existing modal-opener opens the shared modal.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-pt-style-guide]');
    if (!trigger) return;
    var modal = document.getElementById('modal-pt-style-guide');
    if (!modal || !modal.classList.contains('pt-style-guide')) return;
    event.preventDefault();
    event.stopPropagation();
    var guide = resolve(trigger.dataset.ptStyleGuide);
    var context = owner(trigger);
    if (trigger.hidden || !guide || !context || typeof modal.open !== 'function') return;
    var select = context.querySelector(selectSelector);
    var selectId = select && select.id;
    var content = modal.querySelector('[data-pt-style-content]');
    content.replaceChildren(guide.template.content.cloneNode(true));
    modal.querySelector('#pt-style-guide-title').textContent = guide.template.dataset.title;
    var carousel = content.querySelector('.pt-style-cards');
    carousel.replaceChildren.apply(carousel, guide.styles.map(function (style) { return style.card.cloneNode(true); }));
    window.PTStyleCatalog.hydrateImages(content);
    var cards = Array.from(carousel.children);
    var currentCard;
    cards.forEach(function (card) {
      var option = matchingOption(select, card);
      var current = !!option && option.selected;
      card.classList.toggle('is-current', current);
      card.querySelector('[data-pt-style-current]').hidden = !current;
      var action = card.querySelector('[data-pt-style-select]');
      action.hidden = !option || current;
      if (current) currentCard = card;
      action.addEventListener('click', function () {
        // Re-resolve the live dropdown: builder renders may replace its DOM.
        var liveSelect = selectId && document.getElementById(selectId);
        var liveOwner = liveSelect && owner(liveSelect);
        var liveTrigger = liveOwner && liveOwner.querySelector('[data-pt-style-guide]');
        if (!liveTrigger || resolve(liveTrigger.dataset.ptStyleGuide) !== guide) return;
        var liveOption = matchingOption(liveSelect, card);
        if (!liveOption) return;
        liveSelect.value = liveOption.value;
        liveSelect.dispatchEvent(new Event('change', { bubbles: true }));
        // Matching rebuilds the person card; return focus to its replacement.
        var updated = document.getElementById(selectId);
        if (updated) {
          var dropdown = updated.closest('pt-style-select');
          modal.openedBy = dropdown ? dropdown.querySelector('button') : updated;
        }
        modal.close();
      });
    });
    content.querySelectorAll('[data-pt-style-view]').forEach(function (button) {
      button.addEventListener('click', function () {
        var card = button.closest('[data-pt-style-name]');
        card.querySelectorAll('[data-pt-style-image]').forEach(function (image) {
          image.hidden = image.dataset.ptStyleImage !== button.dataset.ptStyleView;
        });
        window.PTStyleCatalog.hydrateImages(card, true);
        card.querySelectorAll('[data-pt-style-view]').forEach(function (view) {
          view.setAttribute('aria-pressed', String(view === button));
        });
      });
    });
    var indicator = content.querySelector('[data-pt-style-position]');
    function updatePosition() {
      if (!cards.length) { indicator.hidden = true; return; }
      var left = carousel.getBoundingClientRect().left;
      var index = cards.reduce(function (best, card, i) {
        return Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? i : best;
      }, 0);
      indicator.hidden = cards.length < 2;
      indicator.textContent = (index + 1) + ' / ' + cards.length;
    }
    carousel.addEventListener('scroll', updatePosition, { passive: true });
    modal.open(trigger.querySelector('button') || trigger);
    modal.querySelector('.modal__content').scrollTop = 0;
    requestAnimationFrame(function () {
      if (currentCard) carousel.scrollLeft = currentCard.offsetLeft - cards[0].offsetLeft;
      updatePosition();
    });
  }, true);

  refreshTriggers();
  // The builders replace their cards when gender/person context changes.
  new MutationObserver(function (records) {
    var changed = records.some(function (record) {
      return Array.from(record.addedNodes).some(function (node) {
        return node.nodeType === 1 && (node.matches('[data-pt-style-guide], #modal-pt-style-guide') || node.querySelector('[data-pt-style-guide], #modal-pt-style-guide'));
      });
    });
    if (changed) refreshTriggers();
  }).observe(document.body, { childList: true, subtree: true });
})();
